export default {
  getLead: () => {
    const rawLead = localStorage.getItem('lead');
    return JSON.parse(rawLead);
  },
  saveLead: leadData => {
    localStorage.setItem('lead', JSON.stringify(leadData));
  },
  removeLead: () => {
    localStorage.removeItem('lead');
  },
};
